import { infer as Infer, z } from 'zod';

import { userPublicSchema } from '#user/userPublic.schema';

export const groupPublicSchema = z.object({
  id: z.number(),
  name: z.string(),
  desc: z.string().nullable(),
  avatarURL: z.string().nullable(),
  chatId: z.number().nullable(),
  directoryId: z.string(),
  updatedAt: z.string(),
  createdAt: z.string(),
  users: z.array(userPublicSchema),
  slots: z.number().nullable(),
});

export type GroupPublicSchema = Infer<typeof groupPublicSchema>;

export const groupPublicToId = z.codec(groupPublicSchema, z.number().int().positive(), {
  decode: (group) => group.id,
  encode: () => {
    throw new Error('Cannot encode an id back to a GroupPublic');
  },
});
